import { call, put } from "redux-saga/effects";
import moment from "moment";
import { repeatArray } from "../../Modules/utils/RepeatFunctions/Schedule";
import { Decrypt_Value, Encrypt_Value } from "../EncryptDecrypt";
import {
  SetUpcomingAppointment,
  GetUpcomingAppointment,
  setProvidersList,
  setFacilityList,
  appointmentSaved,
  waitListAppointmentSaved,
  clearAppointmentData,
  setProviderAvailablity,
  SetPastAppt,
  SetCancelAppt,
  setPortalAppAvailablity,
  setOnsiteAppReq,
  setBillingFacility,
} from "../../StateManagement/Reducers/AppointmentsState";

import {
  upcomingAppointmentsApi,
  providersApi,
  facilityApi,
  addAppointmentApi,
  addWaitListAppointmentApi,
  EditAppointmentApi,
  EditWaitListAppointmentApi,
  AvailablityApi,
  CancelAppointment_Api,
  waitlistDelete_Api,
  PastAppointment_Api,
  PortalAppAvailablityApi,
  OnsiteAppReqApi,
  BillingFacilityApi,
} from "../Apis/AppointmentsApi";
import { convertUTCToPatientTime } from "../../Modules/utils/RepeatFunctions/Timezone";

const Delay = (ms) => new Promise((res) => setTimeout(res, ms));

export function* upcomingAppointments({ payload }) {
  try {
    const res = yield call(upcomingAppointmentsApi, payload);
    if (res.status === 200) {
      const decrptedResponse = Decrypt_Value(res.data, "vozoportal");

      decrptedResponse.forEach((item) => {
        // console.log("Before Conversion", item);

        if (!item.pc_start_utc || !item.pc_end_utc) {
          console.log(`Item ${item.pc_eid} missing start/end UTC:`, {
            start: item.pc_start_utc,
            end: item.pc_end_utc,
          });
          return;
        }

        const appointmentPatientTimezone =
          item.patient_timezone_at_booking || null;

        const start = convertUTCToPatientTime(
          item.pc_start_utc,
          appointmentPatientTimezone,
        );

        const end = convertUTCToPatientTime(
          item.pc_end_utc,
          appointmentPatientTimezone,
        );
        // console.log("UTC Start:", item.pc_start_utc);
        // console.log("UTC End:", item.pc_end_utc);

        // console.log("Converted Start:", start);
        // console.log("Converted End:", end);

        item.Time = `${start.time}-${end.time}`;
        item.pc_eventDate = moment(start.date).format("dddd DD MMM YYYY");

        // console.log("After Conversion", item);
        const durationMinutes = Math.round((end.raw - start.raw) / 60000);

        item.duration = `${start.time}-${end.time}-${durationMinutes} mins`;

        item.Time = `${start.time}-${end.time}`;
        item.pc_startTime = start.time;
        item.ApptFromDate = start.date;
        item.pc_eventDate = moment(start.date).format("dddd DD MMM YYYY");
        item.ApptFromDateWithtime = `${start.date} ${moment(start.time, "hh:mm A").format("HH:mm:ss")}`;

        // console.log(
        //   `Item ${item.pc_eid} ApptFromDateWithtime:`,
        //   item.ApptFromDateWithtime,
        // );
      });

      const current = convertUTCToPatientTime(
        moment.utc().format("YYYY-MM-DD HH:mm:ss"),
      );
      var currdate = `${current.date} ${moment(current.time, "hh:mm A").format("HH:mm:ss")}`;

      const currentUtc = moment.utc();

      let RepeatValues = decrptedResponse.filter(
        (pat) => pat.pc_recurrtype !== "0",
      );
      let NotRepeatValues = decrptedResponse.filter(
        (pat) => pat.pc_recurrtype === "0",
      );

      var repeatValues = repeatArray(RepeatValues, "FutureAppointment");

      let repeatValuesWithDate = repeatValues[1].filter(
        (pat) => pat.ApptFromDateWithtime > currdate,
      );

      const groupedData = {};
      repeatValuesWithDate.forEach((item) => {
        const { pc_eid, ApptFromDate } = item;
        if (!groupedData[pc_eid]) {
          groupedData[pc_eid] = { pc_eid, AppDate: [], ...item };
        }
        if (groupedData[pc_eid].AppDate.length < 30) {
          groupedData[pc_eid].AppDate.push(ApptFromDate);
        }
      });

      const groupedArray = Object.values(groupedData);

      // let NotRepeatValuesWithDate = NotRepeatValues.filter((pat) => {
      //   const isUpcoming = pat.ApptFromDateWithtime > currdate;
      //   // console.log(
      //   //   `Checking Item ${pat.pc_eid} - ApptFromDateWithtime: ${pat.ApptFromDateWithtime}, currdate: ${currdate}, isUpcoming: ${isUpcoming}`,
      //   // );
      //   return isUpcoming;
      // });
      let NotRepeatValuesWithDate = NotRepeatValues.filter((pat) => {
        if (!pat.pc_end_utc) {
          return pat.ApptFromDateWithtime > currdate;
        }

        const appointmentEndUtc = moment.utc(pat.pc_end_utc);

        if (!appointmentEndUtc.isValid()) {
          return pat.ApptFromDateWithtime > currdate;
        }

        return appointmentEndUtc.isAfter(currentUtc);
      });

      let FinalResult = groupedArray.concat(NotRepeatValuesWithDate);

      FinalResult.sort((a, b) => {
        const date1 = new Date(a.ApptFromDateWithtime);
        const date2 = new Date(b.ApptFromDateWithtime);
        return date1 - date2;
      });

      // console.log("FinalResult", FinalResult);
      // console.log("FinalResult Length", FinalResult.length);

      yield put(SetUpcomingAppointment(FinalResult));
    }
  } catch (e) {
    yield put(SetUpcomingAppointment([]));
    console.log(e.message);
  }
}

export function* CancelApptApi({ payload }) {
  const credential = payload;
  let encryptdata = Encrypt_Value(credential, "vozoportal");
  try {
    const res = yield call(CancelAppointment_Api, encryptdata);
    if (res) {
      yield put(SetCancelAppt());
      yield put(GetUpcomingAppointment());
    }
  } catch (e) {
    console.log(e.message);
  }
}

export function* deleteWaitlistApi({ payload }) {
  const credential = payload;
  let encryptdata = Encrypt_Value(credential, "vozo");
  try {
    const res = yield call(waitlistDelete_Api, encryptdata);
    if (res) {
      yield put(SetCancelAppt());
      yield put(GetUpcomingAppointment());
    }
  } catch (e) {
    console.log(e.message);
  }
}

// export function* PastApptAPi() {
//   try {
//     const res = yield call(PastAppointment_Api);
//     if (res.status === 200) {
//       const decrptedResponse = Decrypt_Value(res.data, "vozoportal");

//       decrptedResponse.forEach((item) => {
//         if (!item.pc_start_utc || !item.pc_end_utc) return;

//         const start = convertUTCToPatientTime(item.pc_start_utc);
//         const end = convertUTCToPatientTime(item.pc_end_utc);

//         item.Time = `${start.time}-${end.time}`;
//         item.pc_startTime = start.time;

//         item.ApptFromDate = start.date;
//         item.Date = start.date;

//         item.pc_eventDate = moment(start.date).format("ddd DD MMM YYYY");

//         item.ApptFromDateWithtime = `${start.date} ${moment(start.time, "hh:mm A").format("HH:mm:ss")}`;
//       });
//       var currdate = moment().format("YYYY-MM-DD HH:mm:ss");
//       let RepeatValues = decrptedResponse.filter(
//         (pat) => pat.pc_recurrtype !== "0",
//       );
//       let NotRepeatValues = decrptedResponse.filter(
//         (pat) => pat.pc_recurrtype === "0",
//       );
//       RepeatValues.forEach((pat) => {
//         pat.pc_apptstatus = "COMPLETED";
//       });

//       var repeatValues = repeatArray(RepeatValues, "FutureAppointment");

//       let repeatValuesWithDate = repeatValues[1].filter(
//         (pat) => pat.ApptFromDateWithtime < currdate,
//       );

//       let NotRepeatValuesWithDate = NotRepeatValues.filter(
//         (pat) => pat.ApptFromDateWithtime < currdate,
//       );

//       let FinalResult = repeatValuesWithDate.concat(NotRepeatValuesWithDate);

//       FinalResult.sort((a, b) => {
//         const date1 = new Date(a.ApptFromDateWithtime);
//         const date2 = new Date(b.ApptFromDateWithtime);
//         return date1 - date2;
//       });
//       FinalResult.reverse();

//       const filteredData = FinalResult.slice(0, 30);
//       yield put(SetPastAppt(filteredData));
//     }
//   } catch (e) {
//     yield put(SetPastAppt([]));
//     console.log(e.message);
//   }
// }

export function* PastApptAPi() {
  try {
    const res = yield call(PastAppointment_Api);

    if (res.status === 200) {
      const decrptedResponse = Decrypt_Value(res.data, "vozoportal");

      // Convert UTC to Patient Timezone
      decrptedResponse.forEach((item) => {
        if (!item.pc_start_utc || !item.pc_end_utc) return;

        const appointmentPatientTimezone =
          item.patient_timezone_at_booking || null;

        const start = convertUTCToPatientTime(
          item.pc_start_utc,
          appointmentPatientTimezone,
        );

        const end = convertUTCToPatientTime(
          item.pc_end_utc,
          appointmentPatientTimezone,
        );

        const durationMinutes = Math.round((end.raw - start.raw) / 60000);

        item.duration = `${start.time}-${end.time}-${durationMinutes} mins`;
        item.Time = `${start.time}-${end.time}`;
        item.pc_startTime = start.time;

        item.ApptFromDate = start.date;
        item.Date = start.date;
        item.pc_eventDate = moment(start.date).format("ddd DD MMM YYYY");

        item.ApptFromDateWithtime = `${start.date} ${moment(start.time, "hh:mm A").format("HH:mm:ss")}`;
      });

      // Current time in Patient Timezone
      const current = convertUTCToPatientTime(
        moment.utc().format("YYYY-MM-DD HH:mm:ss"),
      );

      const currdate = `${current.date} ${moment(current.time, "hh:mm A").format("HH:mm:ss")}`;
      const currentUtc = moment.utc();

      let RepeatValues = decrptedResponse.filter(
        (pat) => pat.pc_recurrtype !== "0",
      );

      let NotRepeatValues = decrptedResponse.filter(
        (pat) => pat.pc_recurrtype === "0",
      );

      RepeatValues.forEach((pat) => {
        pat.pc_apptstatus = "COMPLETED";
      });

      const repeatValues = repeatArray(RepeatValues, "FutureAppointment");

      const repeatValuesWithDate = repeatValues[1].filter(
        (pat) => pat.ApptFromDateWithtime < currdate,
      );

      // const NotRepeatValuesWithDate = NotRepeatValues.filter(
      //   (pat) => pat.ApptFromDateWithtime < currdate,
      // );
      const NotRepeatValuesWithDate = NotRepeatValues.filter((pat) => {
        if (!pat.pc_end_utc) {
          return pat.ApptFromDateWithtime < currdate;
        }

        const appointmentEndUtc = moment.utc(pat.pc_end_utc);

        if (!appointmentEndUtc.isValid()) {
          return pat.ApptFromDateWithtime < currdate;
        }

        return !appointmentEndUtc.isAfter(currentUtc);
      });

      let FinalResult = repeatValuesWithDate.concat(NotRepeatValuesWithDate);

      FinalResult.sort((a, b) => {
        return (
          new Date(a.ApptFromDateWithtime) - new Date(b.ApptFromDateWithtime)
        );
      });

      FinalResult.reverse();

      yield put(SetPastAppt(FinalResult.slice(0, 30)));
    }
  } catch (e) {
    yield put(SetPastAppt([]));
    console.log(e.message);
  }
}
export function* providersWorker({ payload }) {
  let text = payload;
  let text_encrpt = Encrypt_Value(text, "vozo_portal");
  try {
    const res = yield call(providersApi, text_encrpt);

    if (res.status === 200) {
      let data = Decrypt_Value(res.data, "vozo_portal");
      yield put(setProvidersList(data));
    }
  } catch (e) {
    console.log(e.message);
    yield put(setProvidersList([]));
  }
}

export function* facilityWorker({ payload }) {
  let find = payload;
  let find_encrpt = Encrypt_Value(find, "vozo_portal");
  try {
    const res = yield call(facilityApi, find_encrpt);
    if (res.status === 200) {
      let data = Decrypt_Value(res.data, "vozo_portal");
      yield put(setFacilityList(data));
    }
  } catch (e) {
    console.log(e.message);
    yield put(setFacilityList([]));
  }
}

export function* AddAppointmentWorker({ payload }) {
  let data = payload;
  console.log("========== SAGA ADD APPOINTMENT PAYLOAD ==========");
  console.log("Payload before encryption:", data);
  console.log("Appointment Type:", data?.appttype);
  console.log("==================================================");
  let data_encrpt = Encrypt_Value(data, "vozo_portal");

  try {
    const res = yield call(addAppointmentApi, data_encrpt);
    if (res.status === 200) {
      if (res.data === "not allowed") {
        yield put(
          appointmentSaved({
            color: "danger",
            message:
              "Appointment cannot be scheduled. It overlaps with telehealth based appointment availability.",
          }),
        );
        yield Delay(2000);
      } else {
        yield put(
          appointmentSaved({
            color: "success",
            message: "Appointment added successfully !",
          }),
        );
        // return
        yield put(GetUpcomingAppointment());
        yield Delay(1500);
        yield put(clearAppointmentData("/appointment/past_appointment"));
      }
    }
  } catch (e) {
    console.log(e.message);
    yield put(
      appointmentSaved({
        color: "danger",
        message: "Failed to add Appointment",
      }),
    );
    yield Delay(1000);
    yield put(clearAppointmentData("/appointment/past_appointment"));
  }
}
export function* AddWaitListAppointmentWorker({ payload }) {
  let data = payload;
  let data_encrpt = Encrypt_Value(data, "vozo");
  try {
    const res = yield call(addWaitListAppointmentApi, data_encrpt);
    if (res.status === 200) {
      if (res.data === "not allowed") {
        yield put(
          waitListAppointmentSaved({
            color: "danger",
            message:
              "Appointment cannot be scheduled. It overlaps with telehealth based appointment availability.",
          }),
        );
        yield Delay(2000);
      } else {
        yield put(
          waitListAppointmentSaved({
            color: "success",
            message: "WaitList Appointment added successfully !",
          }),
        );
        // return
        yield put(GetUpcomingAppointment());
        yield Delay(1500);
        yield put(clearAppointmentData("/appointment/past_appointment"));
      }
    }
  } catch (e) {
    console.log(e.message);
    yield put(
      waitListAppointmentSaved({
        color: "danger",
        message: "Failed to add Appointment",
      }),
    );
    yield Delay(1000);
    yield put(clearAppointmentData("/appointment/past_appointment"));
  }
}

export function* EditWaitListAppointmentWorker({ payload }) {
  let data = payload;
  let data_encrpt = Encrypt_Value(data, "vozo");

  try {
    let res = yield call(EditWaitListAppointmentApi, data_encrpt);
    if (res.status === 200) {
      yield put(
        appointmentSaved({
          color: "success",
          message: "WaitListAppointment edited successfully !",
        }),
      );
      yield put(GetUpcomingAppointment());
      yield Delay(1000);
      yield put(clearAppointmentData("/appointment/past_appointment"));
    }
  } catch (e) {
    console.log(e.message);
    yield put(
      appointmentSaved({
        color: "danger",
        message: "Failed to edit Appointment",
      }),
    );
    yield Delay(1000);
    yield put(clearAppointmentData("/appointment/past_appointment"));
  }
}

export function* EditAppointmentWorker({ payload }) {
  let data = payload;
  let id = data.eid;
  let data_encrpt = Encrypt_Value(data, "vozo_portal");

  try {
    let res = yield call(EditAppointmentApi, { article: data_encrpt, eid: id });
    if (res.status === 200) {
      yield put(
        appointmentSaved({
          color: "success",
          message: "Appointment edited successfully !",
        }),
      );
      yield put(GetUpcomingAppointment());
      yield Delay(1000);
      yield put(clearAppointmentData("/appointment/past_appointment"));
    }
  } catch (e) {
    console.log(e.message);
    yield put(
      appointmentSaved({
        color: "danger",
        message: "Failed to edit Appointment",
      }),
    );
    yield Delay(1000);
    yield put(clearAppointmentData("/appointment/past_appointment"));
  }
}

export function* SetAvailablityWorker({ payload }) {
  let encrpyted = Encrypt_Value(payload, "vozo_portal");
  try {
    let res = yield call(AvailablityApi, encrpyted);
    if (res.status === 200) {
      let data = Decrypt_Value(res.data, "vozo_portal");
      yield put(setProviderAvailablity(data));
    }
  } catch (e) {
    console.log(e.message);
  }
}

export function* SetPortalAppAvailablityWorker({ payload }) {
  let encrpyted = Encrypt_Value(payload, "vozo_portal");
  try {
    let res = yield call(PortalAppAvailablityApi, payload);
    if (res.status === 200) {
      let data = Decrypt_Value(res.data, "vozo_portal");
      yield put(setPortalAppAvailablity(data));
    }
  } catch (e) {
    console.log(e.message);
  }
}

export function* SetOnsiteAppReqWorker({ payload }) {
  let encrpyted = Encrypt_Value(payload, "vozo_portal");
  try {
    let res = yield call(OnsiteAppReqApi, encrpyted);
    if (res.status === 200) {
      let data = Decrypt_Value(res.data, "vozo_portal");
      yield put(setOnsiteAppReq(data));
    }
  } catch (e) {
    console.log(e.message);
  }
}

export function* BillingFacilityWorker() {
  try {
    const res = yield call(BillingFacilityApi);
    if (res.status === 200) {
      const decryptResponse = Decrypt_Value(res.data, "vozo");
      if (decryptResponse === false) {
        yield put(setBillingFacility(null));
      } else {
        yield put(setBillingFacility(decryptResponse.id));
      }
    }
  } catch (e) {
    yield put(setBillingFacility(null));
    console.log(e.message);
  }
}
